<!-- Start Mobile Navbar -->
<div id="offcanvas-flip" class="mobile-navbar uk-mobile-navbar" uk-offcanvas="flip: true; overlay: true">
    <div class="uk-offcanvas-bar">

        <button class="uk-offcanvas-close" type="button" uk-close></button>

        <nav class="uk-navbar-container" data-uk-scrollspy-nav="offset: 0; closest: li; scroll: true">
            <ul class="uk-navbar-nav">
                <li class="uk-active">
                    <!-- <a href="#home" uk-icon="icon: triangle-down">Home</a> -->
                    <a routerLink="/home" routerLinkActive="uk-active">Home</a>
                    <!-- <div uk-dropdown>
                        <ul class="uk-nav uk-dropdown-nav">
                            <li>
                                <a routerLink="/" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="uk-active">Digital Agency - 1</a>
                            </li>
                            <li>
                                <a routerLink="/digital-agency-demo-2" routerLinkActive="uk-active">Digital Agency - 2</a>
                            </li>
                            <li>
                                <a routerLink="/digital-agency-demo-3" routerLinkActive="uk-active">Digital Agency - 3</a>
                            </li>
                            <li>
                                <a routerLink="/digital-agency-demo-4" routerLinkActive="uk-active">Digital Agency - 4</a>
                            </li>
                            <li>
                                <a routerLink="/business-startups" routerLinkActive="uk-active">Business Startups</a>
                            </li>
                            <li>
                                <a routerLink="/seo-agency" routerLinkActive="uk-active">SEO Agency</a>
                            </li>
                            <li>
                                <a routerLink="/corporate-agency" routerLinkActive="uk-active">Corporate Agency</a>
                            </li>
                            <li>
                                <a routerLink="/digital-marketing" routerLinkActive="uk-active">Digital Marketing</a>
                            </li>
                            <li>
                                <a routerLink="/business-consulting" routerLinkActive="uk-active">Business Consulting</a>
                            </li>
                            <li>
                                <a routerLink="/creative-agency" routerLinkActive="uk-active">Creative Agency</a>
                            </li>
                        </ul>
                    </div> -->
                </li>
                <li>
                    <a routerLink="/about" routerLinkActive="uk-active">About</a>
                </li>
                <li>
                    <a routerLink="/services" routerLinkActive="uk-active">Services</a>
                    <!-- <div uk-dropdown>
                        <ul class="uk-nav uk-dropdown-nav">
                            <li>
                                <a routerLink="/services" routerLinkActive="uk-active">Services</a>
                            </li>
                            <li>
                                <a routerLink="/service-details" routerLinkActive="uk-active">Service Details</a>
                            </li>
                        </ul>
                    </div> -->
                </li>
                <!-- <li>
                    <a href="#" uk-icon="icon: triangle-down">Projects</a>
                    <div uk-dropdown>
                        <ul class="uk-nav uk-dropdown-nav">
                            <li>
                                <a routerLink="/projects" routerLinkActive="uk-active">Project</a>
                            </li>
                            <li>
                                <a routerLink="/project-details" routerLinkActive="uk-active">Project Details</a>
                            </li>
                        </ul>
                    </div>
                </li> -->
                <!-- <li>
                    <a routerLink="/team" routerLinkActive="uk-active">Team</a>
                </li> -->
                <!-- <li>
                    <a routerLink="/testimonials" routerLinkActive="uk-active">Testimonials</a>
                </li> -->
                <li>
                    <a routerLink="/blog"  routerLinkActive="uk-active">Blog</a>
                    <!-- <div uk-dropdown>
                        <ul class="uk-nav uk-dropdown-nav">
                            <li>
                                <a routerLink="/blog" routerLinkActive="uk-active">Blog</a>
                            </li>
                            <li>
                                <a routerLink="/blog-details" routerLinkActive="uk-active">Blog Details</a>
                            </li>
                        </ul>
                    </div> -->
                </li>
                <li>
                    <a href="#" uk-icon="icon: triangle-down">Pages</a>
                    <div uk-dropdown>
                        <ul class="uk-nav uk-dropdown-nav">
                            <li>
                                <a routerLink="/privacy-policy" routerLinkActive="uk-active">Privacy Policy</a>
                            </li>
                            <li>
                                <a routerLink="/term-conditions" routerLinkActive="uk-active">Terms & Conditions</a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li>
                    <a routerLink="/contact" routerLinkActive="uk-active">Contact</a>
                </li>
            </ul>
        </nav>
    </div>
</div>
<!-- End Mobile Navbar -->

<!-- Start Navbar Area -->
<header class="header-area {{navClass}}" data-uk-sticky="top: 0; animation: uk-animation-slide-top;">
    <div class="uk-container">
        <div class="uk-navbar">
            <div class="logo uk-navbar-left">
                <a routerLink="/home">
                    <img style="height: 45px;" src="assets/img/{{logo}}" alt="logo"><br>
                </a>
            </div>

            <div class="uk-navbar-toggle" id="navbar-toggle" uk-toggle="target: #offcanvas-flip">
                <span></span>
                <span></span>
                <span></span>
            </div>

            <div class="navbar uk-navbar-right">
                <nav class="uk-navbar-container" data-uk-scrollspy-nav="offset: 0; closest: li; scroll: true">
                    <ul class="uk-navbar-nav">
                        <li>
                            <!-- <a href="#home" uk-icon="icon: triangle-down">Home</a> -->
                            <a routerLink="/home"  routerLinkActive="uk-active">Home</a>
                            <!-- <div uk-dropdown>
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li>
                                        <a routerLink="/" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="uk-active">Digital Agency - 1</a>
                                    </li>
                                    <li>
                                        <a routerLink="/digital-agency-demo-2" routerLinkActive="uk-active">Digital Agency - 2</a>
                                    </li>
                                    <li>
                                        <a routerLink="/digital-agency-demo-3" routerLinkActive="uk-active">Digital Agency - 3</a>
                                    </li>
                                    <li>
                                        <a routerLink="/digital-agency-demo-4" routerLinkActive="uk-active">Digital Agency - 4</a>
                                    </li>
                                    <li>
                                        <a routerLink="/business-startups" routerLinkActive="uk-active">Business Startups</a>
                                    </li>
                                    <li>
                                        <a routerLink="/seo-agency" routerLinkActive="uk-active">SEO Agency</a>
                                    </li>
                                    <li>
                                        <a routerLink="/corporate-agency" routerLinkActive="uk-active">Corporate Agency</a>
                                    </li>
                                    <li>
                                        <a routerLink="/digital-marketing" routerLinkActive="uk-active">Digital Marketing</a>
                                    </li>
                                    <li>
                                        <a routerLink="/business-consulting" routerLinkActive="uk-active">Business Consulting</a>
                                    </li>
                                    <li>
                                        <a routerLink="/creative-agency" routerLinkActive="uk-active">Creative Agency</a>
                                    </li>
                                </ul>
                            </div> -->
                        </li>
                        <li>
                            <a routerLink="/about" routerLinkActive="uk-active">About</a>
                        </li>
                        <li>
                            <a routerLink="/services" routerLinkActive="uk-active">Services</a>
                            <!-- <div uk-dropdown>
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li>
                                        <a routerLink="/services" routerLinkActive="uk-active">Services</a>
                                    </li>
                                    <li>
                                        <a routerLink="/service-details" routerLinkActive="uk-active">Service Details</a>
                                    </li>
                                </ul>
                            </div> -->
                        </li>
                        <!-- <li>
                            <a href="#" uk-icon="icon: triangle-down">Projects</a>
                            <div uk-dropdown>
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li>
                                        <a routerLink="/projects" routerLinkActive="uk-active">Project</a>
                                    </li>
                                    <li>
                                        <a routerLink="/project-details" routerLinkActive="uk-active">Project Details</a>
                                    </li>
                                </ul>
                            </div>
                        </li> -->
                        <!-- <li>
                            <a routerLink="/team" routerLinkActive="uk-active">Team</a>
                        </li> -->
                        <!-- <li>
                            <a routerLink="/testimonials" routerLinkActive="uk-active">Testimonials</a>
                        </li> -->
                        <li>
                            <a routerLink="/blog"  routerLinkActive="uk-active">Blog</a>
                            <!-- <div uk-dropdown>
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li>
                                        <a routerLink="/blog" routerLinkActive="uk-active">Blog</a>
                                    </li>
                                    <li>
                                        <a routerLink="/blog-details" routerLinkActive="uk-active">Blog Details</a>
                                    </li>
                                </ul>
                            </div> -->
                        </li>
                        <li>
                            <a href="#" uk-icon="icon: triangle-down">Pages</a>
                            <div uk-dropdown>
                                <ul class="uk-nav uk-dropdown-nav">
                                    <li>
                                        <a routerLink="/privacy-policy" routerLinkActive="uk-active">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a routerLink="/term-conditions" routerLinkActive="uk-active">Terms & Conditions</a>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a routerLink="/contact" routerLinkActive="uk-active">Contact</a>
                        </li>
                    </ul>
                </nav>

                <!-- <div class="lang">
                    <form>
                        <div>
                            <select>
                                <option value="eng">En</option>
                                <option value="ge">Ge</option>
                            </select>
                        </div>
                    </form>
                </div> -->
            </div>
        </div>
    </div>
</header>
<!-- End Navbar Area -->